import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import INPUTFILE from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTFILE.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
// Model Structure
export const formInputFileAttr = makeAttrStruct([
    ['class']
]);
export const formInputFileData = makeDataStruct([
    ['field', fieldModel()],
    ['message', spanModel()],
    ['base64']
]);
export const formInputFileModel = makeStruct([
    ['attributes', formInputFileAttr],
    ['data', formInputFileData]
]);
// Simplified Model
export function formInputFile(field, message, className, base64) {
    return {
        attributes: formInputFileAttr(className),
        data: formInputFileData(field, message, base64)
    };
}
/** A file INPUT element for a FORM Container */
export default class FORMINPUTFILE extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTFILE(this, model);
    }
}
